import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { ENTITY_TYPE, LazyReportContentModal, ReportingContextProvider } from '@fiverr-private/content_reporting';
import { ReportPopover } from './ReportPopover';

export const GigReportCta: React.FC = () => {
  const {
    isPageOwner,
    currentUser,
    general: { gigId, sellerId },
  } = useGigPageContext();

  if (isPageOwner || currentUser?.status === 'restricted') {
    return null;
  }

  return (
    <Stack onClick={(e: React.MouseEvent) => e.stopPropagation()}>
      <ReportingContextProvider
        entityId={`${gigId}`}
        entityType={ENTITY_TYPE.GIG}
        sellerId={`${sellerId}`}
        fetchOnMount={false}
      >
        <ReportPopover />
        <LazyReportContentModal />
      </ReportingContextProvider>
    </Stack>
  );
};
